import React, { useEffect, useState } from "react";
import PendingCustomerList from "./PendingCustomerList";
import { Api } from "../Api/Api";

const PendingCustomersPage = () => {
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadPendingCustomers();
  }, []);

  // SAME AS PaymentList
  const getCompletedWeeks = (givenDate) => {
    const start = new Date(givenDate);
    const today = new Date();
    start.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    const diffDays = Math.floor((today - start) / 86400000);
    return Math.floor(diffDays / 7);
  };

  const loadPendingCustomers = async () => {
    try {
 
    const custRes = await fetch(`${Api}customers/list.php`);
    const custData = await custRes.json();

    const payRes = await fetch(`${Api}payments/list.php`);
    const payData = await payRes.json();


      const customerList = custData.customers || [];
      const payments = payData.payments || [];

     const pendingCustomers = customerList
       .map((c) => {
         const weekly = Number(c.weekly_interest_amount || 0);
         const completedWeeks = getCompletedWeeks(c.given_date);

         const customerPayments = payments.filter(
           (p) => Number(p.customer_id) === Number(c.id),
         );

         // ✅ SAME AS CustomerDetails
         const totalDue = completedWeeks * weekly;

         const totalPaid = customerPayments.reduce(
           (sum, p) => sum + Number(p.paid_amount || 0),
           0,
         );

         const pending = Math.max(totalDue - totalPaid, 0);

         return {
           ...c,
           pending,
         };
       })
       .filter((c) => c.pending > 0);


      setCustomers(pendingCustomers);
    } catch (err) {
      console.error(err);
      setCustomers([]);
    }

    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-gray-50 p-8">
      <div className="max-w-7xl mx-auto space-y-6">
        <h1 className="text-3xl font-bold text-gray-900">Pending Customers</h1>
      
        <div className="bg-white rounded-xl shadow border">
          {loading ? (
            <div className="p-10 text-center text-gray-500">
              Loading pending customers…
            </div>
          ) : (
            <PendingCustomerList customers={customers} />
          )}
        </div>
      </div>
    </div>
  );
};

export default PendingCustomersPage;
